import React from "react";

import { Controller } from "react-hook-form";

interface IInputTextField {
    control: any;
    name: string;
    placeholder: string;
}
const InputTextField = ({ control, name, placeholder }: IInputTextField) => {
    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState }) => <div className='textField'>
                <input placeholder={placeholder} {...field}
                    className={ fieldState.error ? "error" : "" } />
                {
                    // fieldState.error && <div>{fieldState.error?.message}</div>
                }
            </div>}
        />
    );
};

export default InputTextField;
